// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.homeContainerOffice {
    width: 100%;
    color: aliceblue;
   
}

.Office {
    color: #e1e1e1;
   
    height: 96vh;
}

.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled{
    color: #666666 !important;
    background: #919191 !important;
    border: 1px solid #999999 !important;
  
  }

.sensorIcon img {
    width: 80px !important;
    height: 80px !important;
    object-fit: contain !important;

}

.HeadingOfDanger .MuiSvgIcon-root {
    fill: #E16162 !important;
    margin-bottom: -3px;
    
}

.HeadingOfDanger {
    background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%)!important;
    font-size: 16px !important;
    height: 30px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.roomClimateHeader {
    background-color: #195faf;
    width: 93%;
    height: 40px;
}

.danger {
    height: auto;
    width: 250px;
    margin-top: 20px;
    margin: 10px;
    

}

.homeContainerOffice .MuiGrid-root {
    display: 'flex';
    justify-content: 'center';
    align-items: 'center';
}

.danger div {
    text-align: center;
    font-size: 14px;
    color: white;
    padding: 5px;
    display: inherit;
    align-items: center;
    justify-content: center;
    background-color: #282B30;
    height: auto;
}

.bodyOfDanger {
    background-color: #282B30;
    height: auto !important;
    text-align: center;
    padding: 10px !important;
}

.roomClimateBody {
    width: 93%;
    background-color: #282B30;
    height: 200px;
}



.visitorHeader {
    background-color: #19191C !important;
    font-size: 18px !important;
    height: 30px !important;
}

.visitorBody {
    background-color: #282B30;
    height: auto !important;
    padding: 10px !important;
}

.warnSign {
    background-color: #E16162;
    border-radius: 50%;
    padding: 4px;
}

.check {
    background-color: #4996EE;
    border-radius: 50%;
    padding: 3px;
}

.dangerIcon .css-i4bv87-MuiSvgIcon-root {
    color: #E16162 !important;
    font-size: 5.5rem !important;
    fill: #E16162 !important;

}

.visitor {
    font-size: 14px;
    color: white;
    padding: 5px;
    display: inherit;
    align-items: center;
    justify-content: center;
    background-color: #282B30;
    height: auto;
    margin-top: 10px;

}

.temperature {
    font-size: 14px;
}

.temperature span .css-i4bv87-MuiSvgIcon-root {
    font-size: 1.2rem !important;
}

.updatedTime {
    font-size: 12px;
}

.updatedTime span .css-i4bv87-MuiSvgIcon-root {
    font-size: 1.2rem !important;
}

.dangerAlert {
    margin-bottom: 15px;
}

.Office button {
    border-radius: 0 !important;
    background: linear-gradient(90deg, rgba(73, 150, 238) 0%, rgba(37, 75, 119) 100%);
    color: #fff;
    margin-bottom: 15px;
    margin-top: 0;
}

.Office button:hover {
    background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%);
}

.dangerContainer{

   width: 100%;
   display: flex;
   flex-direction: row;
   flex-wrap: wrap;
   justify-content: center;
   align-items: center;
}

.addNewSensorButton{
    text-align: right;
}




@media (max-width: 1200px) {
    .visitor {

        margin-top: 20px;

    }
  }
  
  @media (max-width: 900px) {
  .addNewSensorButton{
    text-align: center;
}
  }`, "",{"version":3,"sources":["webpack://./src/components/ItemMonitoring/ItemMonitoring.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,gBAAgB;;AAEpB;;AAEA;IACI,cAAc;;IAEd,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,oCAAoC;;EAEtC;;AAEF;IACI,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;;AAElC;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;;AAEvB;;AAEA;IACI,2FAA2F;IAC3F,0BAA0B;IAC1B,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,YAAY;;;AAGhB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,UAAU;IACV,yBAAyB;IACzB,aAAa;AACjB;;;;AAIA;IACI,oCAAoC;IACpC,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;IAC5B,wBAAwB;;AAE5B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;;AAEpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,iFAAiF;IACjF,WAAW;IACX,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,iFAAiF;AACrF;;AAEA;;GAEG,WAAW;GACX,aAAa;GACb,mBAAmB;GACnB,eAAe;GACf,uBAAuB;GACvB,mBAAmB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;;;;AAKA;IACI;;QAEI,gBAAgB;;IAEpB;EACF;;EAEA;EACA;IACE,kBAAkB;AACtB;EACE","sourcesContent":[".homeContainerOffice {\n    width: 100%;\n    color: aliceblue;\n   \n}\n\n.Office {\n    color: #e1e1e1;\n   \n    height: 96vh;\n}\n\n.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled{\n    color: #666666 !important;\n    background: #919191 !important;\n    border: 1px solid #999999 !important;\n  \n  }\n\n.sensorIcon img {\n    width: 80px !important;\n    height: 80px !important;\n    object-fit: contain !important;\n\n}\n\n.HeadingOfDanger .MuiSvgIcon-root {\n    fill: #E16162 !important;\n    margin-bottom: -3px;\n    \n}\n\n.HeadingOfDanger {\n    background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%)!important;\n    font-size: 16px !important;\n    height: 30px !important;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.roomClimateHeader {\n    background-color: #195faf;\n    width: 93%;\n    height: 40px;\n}\n\n.danger {\n    height: auto;\n    width: 250px;\n    margin-top: 20px;\n    margin: 10px;\n    \n\n}\n\n.homeContainerOffice .MuiGrid-root {\n    display: 'flex';\n    justify-content: 'center';\n    align-items: 'center';\n}\n\n.danger div {\n    text-align: center;\n    font-size: 14px;\n    color: white;\n    padding: 5px;\n    display: inherit;\n    align-items: center;\n    justify-content: center;\n    background-color: #282B30;\n    height: auto;\n}\n\n.bodyOfDanger {\n    background-color: #282B30;\n    height: auto !important;\n    text-align: center;\n    padding: 10px !important;\n}\n\n.roomClimateBody {\n    width: 93%;\n    background-color: #282B30;\n    height: 200px;\n}\n\n\n\n.visitorHeader {\n    background-color: #19191C !important;\n    font-size: 18px !important;\n    height: 30px !important;\n}\n\n.visitorBody {\n    background-color: #282B30;\n    height: auto !important;\n    padding: 10px !important;\n}\n\n.warnSign {\n    background-color: #E16162;\n    border-radius: 50%;\n    padding: 4px;\n}\n\n.check {\n    background-color: #4996EE;\n    border-radius: 50%;\n    padding: 3px;\n}\n\n.dangerIcon .css-i4bv87-MuiSvgIcon-root {\n    color: #E16162 !important;\n    font-size: 5.5rem !important;\n    fill: #E16162 !important;\n\n}\n\n.visitor {\n    font-size: 14px;\n    color: white;\n    padding: 5px;\n    display: inherit;\n    align-items: center;\n    justify-content: center;\n    background-color: #282B30;\n    height: auto;\n    margin-top: 10px;\n\n}\n\n.temperature {\n    font-size: 14px;\n}\n\n.temperature span .css-i4bv87-MuiSvgIcon-root {\n    font-size: 1.2rem !important;\n}\n\n.updatedTime {\n    font-size: 12px;\n}\n\n.updatedTime span .css-i4bv87-MuiSvgIcon-root {\n    font-size: 1.2rem !important;\n}\n\n.dangerAlert {\n    margin-bottom: 15px;\n}\n\n.Office button {\n    border-radius: 0 !important;\n    background: linear-gradient(90deg, rgba(73, 150, 238) 0%, rgba(37, 75, 119) 100%);\n    color: #fff;\n    margin-bottom: 15px;\n    margin-top: 0;\n}\n\n.Office button:hover {\n    background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%);\n}\n\n.dangerContainer{\n\n   width: 100%;\n   display: flex;\n   flex-direction: row;\n   flex-wrap: wrap;\n   justify-content: center;\n   align-items: center;\n}\n\n.addNewSensorButton{\n    text-align: right;\n}\n\n\n\n\n@media (max-width: 1200px) {\n    .visitor {\n\n        margin-top: 20px;\n\n    }\n  }\n  \n  @media (max-width: 900px) {\n  .addNewSensorButton{\n    text-align: center;\n}\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
